import { InteractionButton, ToolbarButtonGroup } from "../../lib/ui/toolbar/buttons";
export class NhListSelectButton extends InteractionButton {
    constructor() {
        super('th-list', 'Select parcels in Polygon (Neighborhood)', 'nhButton', 'NH List', ToolbarButtonGroup.Group);
        this.set_interaction('nh');
    }
}
